import ThumbDownSolid from './ThumbDownSolid'

export default ThumbDownSolid
// eslint-disable-next-line import/export
export * from './ThumbDownSolid'
